import { render, staticRenderFns } from "./task_table.vue?vue&type=template&id=585710a0&scoped=true"
import script from "./task_table.vue?vue&type=script&lang=js"
export * from "./task_table.vue?vue&type=script&lang=js"
import style0 from "./task_table.vue?vue&type=style&index=0&id=585710a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585710a0",
  null
  
)

export default component.exports